{
  "account": {
    "backoffice": "Backoffice",
    "changeEmail": "Change email",
    "changePassword": "Change password",
    "confirmNewPassword": "Confirm new password",
    "currentPassword": "Current password",
    "deliveryMethods": "Delivery Methods",
    "deliveryMethodsDesc": "How would you like to receive notifications?",
    "email": "Email",
    "emailCannotBeEmpty": "Email cannot be empty",
    "failedToLoadSettings": "Failed to load notification settings",
    "language": "Language",
    "maintenanceReminders": "Maintenance Reminders",
    "maintenanceRemindersDesc": "Get notified about upcoming maintenance tasks",
    "mobileApp": "Mobile App",
    "myConnections": "My connections",
    "newEmail": "New email",
    "newPassword": "New password",
    "notificationPreferences": "Notification Settings",
    "notificationSettingsError": "Failed to save notification settings",
    "notificationSettingsSaved": "Notification settings saved successfully",
    "notificationTypes": "Notification Types",
    "passwordsNotSame": "New password and confirmation are not equal",
    "successfulEmailChange": "Check your inbox to confirm the email change",
    "successfulPasswordChange": "Password change was successful",
    "warrantyMessages": "New Warranty Messages",
    "warrantyMessagesDesc": "Notifications when warranty providers respond to your case"
  },
  "analytics": {
    "askQuestion": "Ask a question about your data...",
    "clearChat": "Clear chat",
    "loadingSavedChat": "Loading saved chat...",
    "stop": "Stop",
    "title": "Analytics",
    "tryAsking": "Try asking:"
  },
  "building": {
    "analytics": "Analytics",
    "customWarrantyNotificationEmailTemplate": "Custom warranty notification email template",
    "exposeSubmitterEmailInHausing": "Expose submitter in email in Hausing",
    "fileUploadMandatory": "File upload mandatory",
    "frontendFeatureFlags": "Frontend feature flags",
    "hausingBuildingId": "Hausing building ID",
    "hausingClientId": "Hausing client ID",
    "hausingClientSecret": "Hausing client secret",
    "hausingCompanyId": "Hausing company ID",
    "hausingMessageSyncDisabled": "Hausing message sync disabled",
    "hausingOptOut": "Hausing opt-out (skip Hausing requirement for this building)",
    "hausingSyncDisabled": "Hausing sync disabled",
    "hausingTicketDescription": "Hausing ticket description",
    "hausingTicketTitle": "Hausing ticket title",
    "householdImagesPattern": "Household images pattern",
    "lookerReport": "Looker Report",
    "lookerReportLink": "Looker report link",
    "options": "Options",
    "propertyManagerCaseRules": "Property manager case rules",
    "questionsPrompt": "Questions prompt",
    "settings": "Building settings",
    "voiceWarrantyPrompt": "Voice warranty prompt",
    "warrantyAutoReplyMessage": "Warranty auto reply message",
    "warrantyDisabledMessage": "Message when warranty submission is disabled",
    "warrantyEmailUserList": "Warranty email user list",
    "warrantyRules": "Warranty rules",
    "warrantySyncEmail": "Warranty sync email",
    "welcomeEmail": "Welcome email for new users"
  },
  "buildingSettings": {
    "accesses": "Building Admins",
    "addNewAccess": "Add new building admin",
    "ai": {
      "saveError": "Failed to save some AI configuration",
      "saveSuccess": "AI configuration saved successfully"
    },
    "aiSettings": "AI Configuration",
    "analyticsSettings": "Analytics",
    "chatPresetQuestions": "Chat Preset Questions",
    "emailForwarding": "Email forwarding",
    "employeeSettings": "DoBu employee settings",
    "enableInternalAnalytics": "Enable Internal Analytics",
    "fieldSaveError": "Failed to save",
    "hausing": {
      "clientSecretNotStored": "No client secret is saved. Enter one before you enable the connection.",
      "clientSecretReplace": "Enter a new secret to replace the saved secret",
      "clientSecretRequired": "Enter the Hausing client secret",
      "clientSecretStored": "A client secret is saved. Leave this field empty to keep it unchanged.",
      "connectionConfigured": "The Hausing connection is configured.",
      "connectionNotConfigured": "The Hausing connection is not configured.",
      "loadError": "Failed to load Hausing settings",
      "noFlats": "No flats are available.",
      "noRoom": "No Hausing room",
      "roomMappings": "Flat-to-room mapping",
      "roomMappingsHelp": "Map each DoBu flat to its Hausing room.",
      "roomMappingsUnavailable": "Save a Hausing connection before you map flats.",
      "roomSaveError": "Failed to save the flat-to-room mapping",
      "roomsLoadError": "Failed to load Hausing rooms. Check the connection settings.",
      "roomsLoading": "Loading Hausing rooms...",
      "saveError": "Failed to save some Hausing settings",
      "saveSuccess": "Hausing settings saved successfully"
    },
    "hausingSettings": "Hausing",
    "homeownersDashboard": {
      "accountCount": "({{count}} accounts total)",
      "actions": "Actions",
      "apartment": "Apartment",
      "close": "Close",
      "confirmRemove": "Remove",
      "confirmRemoveMessage": "Remove {{name}} from {{apartment}}?",
      "confirmRemoveTitle": "Remove Homeowner",
      "homeowners": "Homeowners",
      "individual": "Individual",
      "loadError": "Failed to load apartment homeowners.",
      "manage": "Manage",
      "noHomeowners": "No homeowners assigned",
      "noResults": "No matching apartments found",
      "organization": "Organization",
      "passwordResetEmailFailed": "The password reset email could not be sent. Please try again.",
      "passwordResetEmailSent": "Password reset email sent to {{email}}.",
      "removeError": "Failed to remove homeowner. Please try again.",
      "removeOwner": "Remove",
      "removeOwnerLabel": "Remove {{name}} from {{apartment}}",
      "resetPassword": "Reset password",
      "searchPlaceholder": "Search apartments or homeowners",
      "sendPasswordResetEmailLabel": "Send password reset email to {{email}}",
      "summary": "{{householdsWithOwners}} / {{householdsCount}} apartments have homeowners assigned",
      "title": "Apartment Homeowners"
    },
    "householdSettings": "Household Settings",
    "lookerReportLink": "Looker Report Link",
    "questionsForwarding": {
      "addRule": "Add Rule",
      "allowForwarding": "Allow questions forwarding?",
      "description": "Describe issues that should be forwarded to this person...",
      "descriptionPlaceholder": "e.g., Plumbing issues, Electrical faults",
      "email": "Email",
      "emailInvalid": "User not found or is not an admin for this building.",
      "emailPlaceholder": "user@example.com",
      "name": "Rule name",
      "namePlaceholder": "e.g. Technical issues",
      "removeRule": "Remove rule",
      "saveSuccess": "Settings saved successfully",
      "title": "Homeowner Questions Forwarding"
    },
    "structuredWarrantySettings": "Advanced Warranty Flow",
    "tallyForms": "Tally Forms",
    "title": "Building Settings",
    "viewAnalytics": "View Analytics",
    "viewLookerReport": "Usage analytics",
    "warranty": {
      "saveError": "Failed to save some warranty settings",
      "saveSuccess": "Warranty settings saved successfully"
    },
    "warrantySettings": "Warranty"
  },
  "case": {
    "addReplyPromptBody": "Add a reply to continue the conversation. The case stays closed.",
    "addReplyPromptTitle": "Add a reply",
    "awaitingReply": "Awaiting reply",
    "closeFollowUp": "No reply needed",
    "closedByService": "Case is closed by after-sales service",
    "closedCantMessage": "This case is closed.",
    "closedFollowUpBanner": "The resident wrote after this case was closed. Reply, or mark that no reply is needed. The case stays closed either way.",
    "completedCases": "Closed",
    "markedAsSolved": "Case is marked as solved",
    "messageWithImage": "Message with image",
    "noCases": "You have no registered cases",
    "notFound": "Case not found",
    "ongoingCases": "Ongoing",
    "previousChatWithBot": "Previous chat with chatbot",
    "reopenPromptBody": "Reopen this case to continue the conversation with the service team. No need to start a new one.",
    "reopenPromptTitle": "Issue still not resolved?",
    "replyWillReopen": "Sending a message will reopen this case.",
    "replyWillStayClosed": "Sending a message notifies the service team. The case stays closed.",
    "submittedCases": "Submitted cases"
  },
  "casePage": {
    "backHome": "Back to home",
    "notFound": "This case could not be opened. The link may be wrong, or you may not have access."
  },
  "chat": {
    "videoAttachment": "Video attachment",
    "askFailed": "Couldn't get an answer. Check your connection and try again.",
    "tryAgain": "Try again",
    "enterQuestion": "Enter a question",
    "escalateNo": "No",
    "escalateNoReply": "Okay, I won't forward it. Ask me anything else about your home.",
    "escalateYes": "Yes",
    "escalationForm": {
      "back": "Back",
      "backToForm": "Back to form",
      "recipient": "Recipient",
      "send": "Send",
      "sendErrorMessage": "There was an error sending your message. Please try again.",
      "sendSuccessMessage": "Your message has been sent successfully.",
      "sending": "Sending...",
      "summary": "Summary of your problem",
      "summaryEditable": "You can edit this summary before sending.",
      "title": "Topic"
    },
    "escalationFailed": "Couldn't forward your question. Try again.",
    "escalationInProgress": "Analyzing your request to connect you with the right expert. This may take a moment...",
    "longConversationWarning": "AI performance may degrade in long chats. Consider starting a new conversation if your topic has changed.",
    "pin1": "The door squeaks",
    "pin2": "What color is my wall?",
    "pin3": "How do I use the thermostat?",
    "question1": "What could I use to clean the wall?",
    "question2": "The door creaks",
    "question3": "A bad smell comes from the bathroom trap",
    "question4": "What tiles are in my hallway?",
    "searchingDocuments": "Searching your home's documents",
    "send": "Send",
    "talkToYourHome": "Talk to your home",
    "warrantyCta": {
      "primary": "Submit warranty case",
      "supporting": "This looks like a warranty issue. Continue in the warranty flow."
    }
  },
  "chatPresetSettings": {
    "addPreset": "Add Language Preset",
    "enable": "Enable Custom Chat Presets",
    "errors": {
      "invalidLanguage": "Language must be a two-letter code (e.g. 'en')",
      "noQuestions": "Each language preset must have at least one question"
    },
    "language": "Language ISO 639-1 (e.g. en et lv)",
    "questionPlaceholder": "Question {{number}}",
    "questions": "Preset Questions",
    "removePreset": "Remove preset",
    "success": {
      "saved": "Chat preset settings saved successfully"
    }
  },
  "common": {
    "cancel": "Cancel",
    "error": {
      "400": "Some of the information is not valid. Check it and try again.",
      "401": "Your session has ended. Please log in again.",
      "403": "You don't have permission to do this.",
      "404": "We couldn't find what you were looking for. It may have been removed.",
      "409": "This conflicts with existing data. Refresh the page and try again.",
      "413": "The file is too large.",
      "500": "Something went wrong. Please try again soon.",
      "loading": "Could not load this page. Please refresh it.",
      "network": "No connection. Check your internet and try again."
    },
    "intervalDays": "{{count}} days",
    "loading": "Loading...",
    "loadingData": "Loading...",
    "returnToHome": "Return to Home",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "tryAgain": "Try again",
    "validating": "Validating..."
  },
  "files": {
    "addFiles": "Add documents",
    "addFilesInstructions": "<span1>Drag</span1> documents here, or <span2>click</span2> to select manually",
    "confirmDeleteBody": "Are you sure you want to delete the selected document?",
    "confirmDeleteNo": "Go back",
    "confirmDeleteTitle": "Delete a document",
    "confirmDeleteYes": "Delete",
    "download": "Download",
    "loadingPreview": "Loading document...",
    "officePreviewHint": "Document not showing?",
    "openInNewTab": "Open in new tab",
    "previewError": {
      "message": "We couldn't display a preview for this document. The file is still accessible and can be opened using your preferred application.",
      "title": "Preview Unavailable"
    },
    "remove": "Delete",
    "save": "Save",
    "stillLoading": "Still loading. Large files can take a minute.",
    "successfullyUploaded": "Files uploaded successfully",
    "uploading": "Uploading files..."
  },
  "home": {
    "myResidences": "My residences",
    "welcome": "Welcome"
  },
  "household": {
    "actions": "AI Search",
    "documents": "Documents",
    "exterior": "Exterior",
    "floor": "floor",
    "maintenanceActivities": "My maintenance activities",
    "maintenanceInfo": "All the necessary maintenance that the home owner must perform is written in the relevant instructions.",
    "mobileApp": {
      "appLink": "Download here",
      "message": "DoBu released a mobile app:"
    },
    "products": "products",
    "productsWithoutRoom": "Products without a room",
    "propertyManagerCases": "Property manager cases",
    "roomsAndProducts": "Rooms and products",
    "warrantyCases": "Warranty cases"
  },
  "loggedInPage": {
    "tallyFormBanner": {
      "button": "Fill Form"
    }
  },
  "login": {
    "aboutInfo": "DoBu is currently only open to homeowners in real estate developments that use us.",
    "alreadyHaveAccount": "Already have a <strong>DoBu</strong> account?",
    "confirm": "Confirm",
    "confirmEmailChange": "Confirm email change",
    "confirmNewPassword": "Confirm new password",
    "confirmPassword": "Confirm password",
    "continue": "Continue",
    "email": "Email",
    "emailChangeSuccessful": "The email change was successful, the new email is {{newEmail}}. Please sign in using a new email",
    "error": {
      "invalidOldPassword": "Invalid old password",
      "notAuthorized": "Not authorized",
      "privateRelayNotAllowed": "Logging in with Apple is not possible when using “Hide My Email”. Please log in using another method or remove your DoBu account from your Apple ID settings and try again.",
      "socialUserNotRegistered": "Email associated with social login is not registered. Please check which email you used to sign up and try again.",
      "tokenExpired": "URL has already been used or has expired",
      "userNotFound": "Account not found. This is a managed application. Please contact your building administrator to set up your account."
    },
    "forgotPassword": "Forgot your password?",
    "login": "Log in",
    "loginError": "User not found, or password is incorrect",
    "logout": "Log out",
    "newEmail": "New email",
    "newPassword": "New password",
    "noAccount": "Don't have a <strong>DoBu</strong> account?",
    "noAccountHeader": "Don't have a DoBu account?",
    "noAccountYet": "No account yet? Your developer or property manager must first add you to your home in DoBu. You will then get an email to set your password.",
    "or": "or",
    "password": "Password",
    "passwordResetInstructions": "Enter your DoBu account email and we will send you a link to set a new password.",
    "privacyPolicy": "Privacy Policy",
    "recoveryFormNotValid": "The recovery form is not valid",
    "resetPassword": "Send link",
    "resetPasswordFormSuccess": "If this email has a DoBu account, we have sent it a link to set a new password. Check your spam folder too.",
    "stuckHelp": "Can't get in? Use the email address DoBu first wrote to you at, or email us: <mail>info@dobu.app</mail>.",
    "resetPasswordSuccess": "Password updated, you can now log in with a new password",
    "seeMore": "See more",
    "wantToTry": "If you are still interested in trying DoBu, you can write to us:"
  },
  "notifications": {
    "alreadyUnsubscribed": "Already unsubscribed on {{date}}",
    "confirmUnsubscribe": "Confirm Unsubscription",
    "confirmUnsubscribeMessage": "Are you sure you want to unsubscribe from notifications? You can always reactivate them in your account settings.",
    "invalidUnsubscribeToken": "Invalid or expired unsubscribe link",
    "unsubscribeConfirm": "Yes, unsubscribe",
    "unsubscribeDescription": "You're about to unsubscribe from all notifications.",
    "unsubscribeErrorGeneric": "An error occurred while unsubscribing",
    "unsubscribeSuccess": "Successfully unsubscribed",
    "unsubscribeSuccessDetail": "You will no longer receive notifications from us.",
    "unsubscribeTitle": "Unsubscribe from Notifications",
    "unsubscribing": "Unsubscribing from notifications..."
  },
  "product": {
    "addDocuments": "Add documents",
    "addNewProduct": "Add new product",
    "addProduct": "Add product",
    "addProductFiles": "Add files",
    "change": "Change",
    "changeProduct": "Change product",
    "confirmMaintenanceDone": "Maintenance done",
    "delete": "Delete",
    "everyNumberOfDays": "Every {{interval}} day",
    "extraInfo": "Extra info",
    "extraInfoAboutTheProduct": "Extra info about the product",
    "maintenanceHistory": "Maintenance history",
    "maintenanceInfo": "Maintenance info",
    "maintenanceInterval": "Maintenance interval in days",
    "maintenanceName": "Maintenance name",
    "maintenanceOverview": {
      "addFileTooltip": "Required",
      "date": "Maintenance Done",
      "document": "Files",
      "scheduledDate": "Deadline"
    },
    "maintenancePopup": {
      "addFile": "Add file",
      "addFileTooltip": "Add file",
      "done": "Done",
      "maintenanceGuide": "Maintenance guide",
      "maintenanceInterval": "Maintenance interval",
      "relatedProduct": "Related product",
      "upcomingMaintenance": "Upcoming maintenance"
    },
    "manufacturer": "Manufacturer",
    "name": "Product name",
    "nextMaintenance": "Next maintenance",
    "productNumber": "Product number",
    "productSuccessfullyChanged": "Product successfully changed",
    "relatedDocuments": "Related documents",
    "relatedRooms": "Related rooms",
    "saveChanges": "Save changes"
  },
  "propertyManagerCase": {
    "addFiles": "Add files",
    "afterSalesService": "After-sales service",
    "answer": "Answer",
    "cancel": "Cancel",
    "caseActions": {
      "addReply": "Add reply",
      "closeCase": "Close case",
      "markAsSolved": "Mark as solved",
      "openCase": "Open case",
      "reopenCase": "Reopen case"
    },
    "caseDescription": "Case description",
    "caseDetails": {
      "address": "Address",
      "category": "Category",
      "name": "Name",
      "phoneNumber": "Phone number",
      "subcontractor": "Service provider"
    },
    "caseStatus": {
      "backlog": "Under Review by Property Manager",
      "closed": "Rejected",
      "inProgress": "In Progress",
      "notDone": "Open",
      "review": "Under Review",
      "solved": "Completed",
      "status": "Status",
      "toDo": "Awaiting Coordination",
      "waiting": "On Hold"
    },
    "caseTitle": "Case title",
    "cases": "Property manager cases",
    "completedCases": "Closed",
    "contactPersonsPhoneNumber": "Contact person's phone number",
    "defectDate": "The date the incident occurred",
    "defectDescription": "The most accurate description of the incident",
    "defectLocation": "The exact location of the incident in the building/apartment",
    "describeCase": "Describe the property manager case",
    "descriptionIsSufficient": "The description is sufficient",
    "downloadFile": "Download file",
    "emailNotification": "Please note that replies to your messages will be sent to your email. Remember to check your spam folder.",
    "forceSubmitCase": "Submit case",
    "maintenanceOverview": {
      "addFileTooltip": "Required",
      "date": "Maintenance Done",
      "document": "Files",
      "scheduledDate": "Deadline"
    },
    "mandatoryFile": "After specifying the case with AI, the option to add a file to the case opens, which is mandatory",
    "noCases": "You have no registered property manager cases",
    "noFilesUploaded": "Fail upload is mandatory",
    "notCovered": "Presumably, the case will not fall under property manager",
    "ongoingCases": "Ongoing",
    "owner": "Owner",
    "pictureDescription": "For faster case processing: please attach two pictures with your notification - one close-up and one from a distance to show the location of the issue.",
    "problemDescriptionInstructions": "The problem should be described as precisely as possible:",
    "sendMessageToDeveloper": "Send a message to the developer",
    "sendMessageToOwner": "Send a message to the resident",
    "sendingCase": "Sending case...",
    "startSubmission": "Start submission",
    "submitCase": "Submit a case",
    "submitNewCase": "Submit a new property manager case",
    "submitOneCase": "Submit one property manager case at a time",
    "submittedCases": "Submitted property manager cases"
  },
  "question": {
    "ask_in_chat_hint": "Questions you ask from the AI assistant via chat will be shown here.",
    "closedByService": "Question is closed by after-sales service",
    "details": {
      "address": "Address",
      "name": "Name"
    },
    "downloadFile": "Download file",
    "emailNotification": "Please note that replies to your messages will be sent to your email. Remember to check your spam folder.",
    "loading": "Loading questions...",
    "markedAsSolved": "Question is marked as solved",
    "messageWithImage": "Message with image",
    "no_questions_yet": "You have not asked any questions yet.",
    "notFound": "Question not found",
    "previousChatWithBot": "Previous chat with chatbot",
    "questions": "Questions",
    "sendMessageToDeveloper": "Send a message to the developer",
    "sendMessageToOwner": "Send a message to the resident",
    "status": {
      "backlog": "Under Review",
      "closed": "Closed",
      "solved": "Solved",
      "status": "Status"
    },
    "submittedQuestions": "Submitted questions"
  },
  "room": {
    "add": "Add room",
    "addNew": "Add new room",
    "change": "Change rooms",
    "delete": "Delete",
    "floor": "Floor",
    "name": "Name",
    "newRoomName": "New room name",
    "outdoor": "Outdoor",
    "rename": "Rename",
    "save": "Save"
  },
  "settings": {
    "accesses": "Access",
    "accountAssignmentFailed": "Failed to assign account.",
    "addNewAccess": "Add new resident",
    "companyFirstUserEmail": "User email",
    "companyFirstUserName": "User name",
    "companyName": "Company name",
    "confirmUnassign": "Unassign",
    "confirmUnassignMessage": "Are you sure you want to remove access for {{name}}?",
    "confirmUnassignTitle": "Remove access",
    "currentWarrantyEndDate": "Current warranty end date",
    "email": "Email",
    "emailRequired": "Email is required",
    "householdSettings": "Household settings",
    "individual": "Person",
    "moreInfoRequired": "Additional information required.",
    "name": "Name",
    "organization": "Company",
    "personName": "Person name",
    "registryCode": "Registry code",
    "registryCodeRequired": "Registry code is required",
    "save": "Save",
    "saveError": "Failed to save configuration",
    "saveFailed": "Failed to save settings",
    "saveSuccess": "Settings saved successfully",
    "saving": "Saving...",
    "title": "Manage access",
    "type": "Type",
    "warrantyEndDate": "Warranty end date",
    "warrantyUpdateFailed": "Failed to update warranty date."
  },
  "structuredWarrantySettings": {
    "addCategory": "Add Category",
    "addSubcontractor": "Add Subcontractor",
    "categories": "Warranty Categories",
    "categoryDescription": "Description (for AI triage)",
    "categoryDescriptionPlaceholder": "Helps AI pick the right category. E.g., Issues with heating, radiators, thermostats, underfloor heating",
    "categoryDocs": "Documents",
    "categoryName": "Category Name",
    "customPrompt": "Custom Prompt (optional)",
    "customPromptPlaceholder": "Guides AI during warranty submission in this category. E.g., Ask user for appliance model number and purchase date",
    "defaultCategory": "Default Category",
    "defaultCategoryDescription": "Description (optional)",
    "defaultCategoryName": "Name (optional)",
    "defaultDocs": "Default Documents",
    "defaultEmail": "Default Email",
    "enable": "Enable Advanced Warranty Flow",
    "hideDocuments": "Hide available documents",
    "noDocsSelected": "No documents selected",
    "noDocuments": "No documents available",
    "noMatchingDocuments": "No matching documents",
    "removeCategory": "Remove category",
    "removeSubcontractor": "Remove subcontractor",
    "searchDocuments": "Search documents...",
    "showDocuments": "Show {{count}} available documents",
    "subcontractorEmail": "Email",
    "subcontractorName": "Name",
    "subcontractors": "Subcontractors"
  },
  "tallyFormSettings": {
    "addForm": "Add Form",
    "bannerText": "Banner Text (e.g., Win $100 if you fill the form!)",
    "bannerTextPlaceholder": "Enter a compelling message to encourage users to fill the form",
    "enable": "Enable TallyForms",
    "errors": {
      "invalidLanguage": "Language must be a two-letter code (e.g. \"en\"). You entered: \"{{language}}\"",
      "invalidUrl": "Use a public Tally.so form URL. You entered: \"{{url}}\"",
      "urlEndsWithEdit": "The URL should not end with \"/edit\". Please provide the public form URL."
    },
    "language": "Language ISO 639-1 (e.g., en, et, lv)",
    "removeRule": "Remove rule",
    "resetStatuses": "Reset Household Statuses",
    "success": {
      "reset": "Household statuses reset successfully",
      "saved": "Tally form settings saved successfully"
    },
    "url": "Tally.so form URL (e.g., https://tally.so/r/xyz)"
  },
  "warranty": {
    "addFiles": "Add files",
    "afterSalesService": "After-sales service",
    "answer": "Answer",
    "cancel": "Cancel",
    "caseActions": {
      "addReply": "Add reply",
      "closeCase": "Close case",
      "markAsSolved": "Mark as solved",
      "openCase": "Open case",
      "reopenCase": "Reopen case"
    },
    "caseDescription": "Case description",
    "caseDetails": {
      "address": "Address",
      "category": "Category",
      "name": "Name",
      "phoneNumber": "Phone number",
      "subcontractor": "Service provider"
    },
    "caseStatus": {
      "backlog": "Under Review by Builder",
      "closed": "Rejected",
      "inProgress": "In Progress",
      "notDone": "Open",
      "review": "Under Review",
      "solved": "Completed",
      "status": "Status",
      "toDo": "Awaiting Coordination",
      "waiting": "On Hold"
    },
    "caseTitle": "Case title",
    "cases": "Warranty cases",
    "completedCases": "Closed",
    "contactPersonsPhoneNumber": "Contact person's phone number",
    "defectDate": "The date the deficiency occurred",
    "defectDescription": "The most accurate description of the defect",
    "defectLocation": "The exact location of the defect in the building/apartment",
    "describeCase": "Describe the warranty case",
    "description": "Description",
    "descriptionIsSufficient": "The description is sufficient",
    "developer": "Developer",
    "downloadFile": "Download file",
    "emailNotification": "Please note that replies to your messages will be sent to your email. Remember to check your spam folder.",
    "file": "File",
    "filesSelected": "file(s) selected",
    "forceSubmitCase": "Submit case",
    "likelyCovered": "This case is likely covered by warranty",
    "maintenanceOverview": {
      "addFileTooltip": "Required",
      "date": "Maintenance Done",
      "document": "Files",
      "scheduledDate": "Deadline"
    },
    "mandatoryFile": "After specifying the case with AI, the option to add a file to the case opens, which is mandatory",
    "mayNotBeCovered": "This case may not be covered by warranty",
    "noCases": "You have no registered warranty cases",
    "noFilesUploaded": "A file (photo/video) is mandatory",
    "notCovered": "Presumably, the case will not fall under warranty",
    "ongoingCases": "Ongoing",
    "owner": "Owner",
    "phoneNumberPlaceholder": "(201) 555-0123",
    "pictureDescription": "To speed up the handling of the case: please include two pictures with your notification, one close up and one from a distance to show the location of the concern.",
    "problemDescriptionInstructions": "The problem should be described as precisely as possible:",
    "sendMessageToDeveloper": "Send a message to the developer",
    "sendMessageToOwner": "Send a message to the resident",
    "sendingCase": "Sending case...",
    "startSubmission": "Start submission",
    "subcontractor": "Service provider",
    "submissionDisabled": "Warranty submission is not yet connected to the builder’s system. This is temporary. Please check again in a few days. For urgent concerns, please send an email to info@dobu.app.",
    "submitCase": "Submit a case",
    "submitClaim": "Submit claim",
    "submitNewCase": "Submit a new warranty case",
    "submitOneCase": "Submit one warranty case at a time",
    "submittedCases": "Submitted warranty cases",
    "voiceAgent": {
      "callInProgress": "Call in progress",
      "callWarrantyAgent": "Call warranty agent",
      "connecting": "Connecting..."
    },
    "warrantyIsValidUntil": "The warranty is valid until {{date}}",
    "warrantyPeriodHasExpired": "The warranty period has expired"
  },
  "warrantyInspection": {
    "defects": "Defects from this inspection",
    "needsAttention_one": "{{count}} needs attention",
    "needsAttention_other": "{{count}} need attention",
    "progress": "{{done}}/{{total}} completed",
    "title": "Warranty end inspection"
  },
  "warrantyIntake": {
    "builderNoteTitle": "From the builder's warranty conditions:",
    "nextIssue": "Next from your list ({{count}} left). Add details if you like, then start.",
    "otherIssuesHint": "Each gets its own case. After you submit this one, we continue with the next.",
    "otherIssuesTitle": "You also mentioned:",
    "selfCheckHint": "If it does not help, submit the case below.",
    "selfCheckTitle": "Before you submit, you can try this from your home's manuals:",
    "skipIssue": "Skip this one",
    "submitted": "Case submitted.",
    "tipOneMessage": "Say in one message what is wrong, where it is and roughly when you noticed it. The case is then ready at once.",
    "tipSeveral": "Several problems? List them all together. Each becomes its own case, one after another, without retyping."
  }
}
